import React from 'react';
import { useParams } from 'react-router-dom';
import LogisticTaskBll from '../../../entities/logistic/logisticTasks/LogisticTaskBll/LogisticTaskBll';
import LogisticMapWidget from '../../../widgets/logistics/LogisticMapWidget/LogisticMapWidget';
import AdvicesInfoSection from '../../../features/logistics/AdvicesInfoSection';

function LogisticMapPanel() {
  const queryParams = useParams();
  const logisticTaskId = parseInt(queryParams.logisticTaskId, 10);

  return (
    <LogisticTaskBll logisticTaskId={logisticTaskId}>
      <AdvicesInfoSection logisticTaskId={logisticTaskId} />
      <LogisticMapWidget />
    </LogisticTaskBll>
  );
}

export default LogisticMapPanel;
